module.exports = __webpack_public_path__ + "static/media/question-circle.2866c3af.svg";